
import { defineComponent } from "vue";
import PlanTransportGroupResultLoadingSchemeJournal from "../PlanTransportGroupResultLoadingSchemeJournal.vue";
import PlanTransportGroupResultSchemeInfo from "./PlanTransportGroupResultSchemeInfo.vue";
import PlanTransportGroupResultScheme from "./PlanTransportGroupResultScheme.vue";
import PlanTransportGroupResultScheme3D from "./PlanTransportGroupResultScheme3D.vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import { getPlanTransportGroupResultLoadingScheme } from "@/api/planTransportGroupResultLoadingSchemeApi";
import { DxSwitch } from "devextreme-vue";

export default defineComponent({
  components: {
    PlanTransportGroupResultLoadingSchemeJournal,
    PlanTransportGroupResultSchemeInfo,
    PlanTransportGroupResultScheme,
    PlanTransportGroupResultScheme3D,
    DxLoadPanel,
    DxSwitch,
  },
  props: {
    parentModel: { required: true },
    parentEditingConfig: { required: false, type: TableEditingConfig },
  },
  computed: {
    loadingSchemeDomId() {
      return `loadingSchemeData_${this.parentModel.id}`;
    },
    container() {
      return {
        length: this.model.transport.length,
        width: this.model.transport.width,
        height: this.model.transport.height,
        type: this.model.transport.transportType,
      };
    },
    rollsList() {
      return this.model.cargoes
        .filter((item) => item.type === 0)
        .map((item, index) => ({
          id: item.id,
          name: item.name,
          diameter: item.diameter,
          height: item.height,
          color: this.getCargoColor(index),
        }));
    },
    palletsList() {
      return this.model.cargoes
        .filter((item) => item.type === 1)
        .map((item, index) => ({
          id: item.id,
          name: item.name,
          length: item.length,
          width: item.width,
          height: item.height,
          color: this.getCargoColor(index),
        }));
    },
  },
  methods: {
    onContentReady(e: any) {
      if (!this.firstRowSelected && e.component.totalCount() > 0) {
        e.component.selectRowsByIndexes([0]);
        this.firstRowSelected = true;
      }
    },
    async onSelectionChanged(e: any) {
      if (e.selectedRowsData && e.selectedRowsData.length) {
        const rowData = e.selectedRowsData[0];
        try {
          this.loading = true;
          const { data } = await getPlanTransportGroupResultLoadingScheme(
            1589,
            rowData.transportType,
            rowData.planTransportResultLoadingSchemeId,
            this.parentModel.id
          );
          this.model = data;
          this.model.number = rowData.number;
          this.$forceUpdate();
        } finally {
          this.loading = false;
        }
      }
    },
    getCargoColor(index: number) {
      const colors = [
        "#FF6F91",
        "#4D96FF",
        "#FFC75F",
        "#00C9A7",
        "#F9F871",
        "#6C5CE7",
        "#FFC9E1",
        "#FF9671",
        "#B8DCD0",
        "#E84393",
      ];
      return colors[index % 10];
    },
  },
  async mounted() {
    this.firstRowSelected = false;
    this.loadingPanelPosition = { of: `#${this.loadingSchemeDomId}` };
  },
  data() {
    return {
      model: {} as any,
      firstRowSelected: false,
      loading: false,
      loadingPanelPosition: {},
      scheme3D: false,
    };
  },
});
